import styled from "styled-components";
import { colors } from "../../../../utils";

// styles

export const DashboardHeader = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  margin-bottom: 20px;

  @media (min-width: 600px) {
    margin-bottom: 40px;
    flex-wrap: wrap;
  }
`;

export const DashboardBody = styled.div`
  border-radius: 12px;
  display: flex;
  flex-direction: column;

  @media (min-width: 1280px) {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    //grid-template-columns: 1fr 1fr;
  }
`;

export const LogoContainer = styled.div`
  margin-left: 15px;

  @media (min-width: 600px) {
    flex: 0.13;
  }
`;

export const TextContainer = styled.div`
  margin-left: 15px;

  @media (min-width: 600px) {
    flex: 0.53;
  }
`;

export const NewFeatureContainer = styled.div`
  width: 100%;
  flex: 0.35;
`;

export const DateText = styled.span`
  font-weight: bold;
`;

export const NotificationContainer = styled.div`
  border-bottom: 1px solid ${colors.gray14};
  padding: 10px;
  &:first-child {
    margin-top: 10px;
  }
  &:last-child {
    border-bottom: none;
  }
`;
